import { FaPaperPlane, FaEnvelope, FaDiscord, FaGithub } from 'react-icons/fa';
import './Contato.css';

const ContactForm = () => {
  return (
    <div className="contact-section">
      <div className="contact-container">
        <h1 className="contact-title">Entre em Contato</h1>

        <p className="contact-description">
          Tem alguma ideia de projeto ou quer conversar sobre programação? Entre em contato comigo através de uma das opções abaixo.
        </p>

        <div className="contact-divider"></div>

        <div className="contact-sections">
          {/* Seção Meios de Contato */}
          <div className="contact-methods">
            <h2 className="section-title">Meios de Contato</h2>

            <div className="contact-item">
              <h3 className="item-label">Email</h3>
              <p className="item-value">joaoqueiroz6632@gmail.com</p>
              <a href="mailto:joaoqueiroz6632@gmail.com" className="item-action">
                <FaEnvelope className="action-icon" />
                Enviar email
              </a>
            </div>

            <div className="contact-item">
              <h3 className="item-label">Discord</h3>
              <p className="item-value">joao6632</p>
              <p className="item-action" onClick={() => navigator.clipboard.writeText('hino07')}>
                <FaDiscord className="action-icon" />
                Me adicione no Discord para batermos um papo
              </p>
            </div>

            <div className="contact-item">
              <h3 className="item-label">GitHub</h3>
              <p className="item-value">Joao6632</p>
              <a href="https://github.com/Joao6632" target="_blank" rel="noopener noreferrer" className="item-action">
                <FaGithub className="action-icon" />
                Ver perfil
              </a>
            </div>
          </div>

          {/* Seção Envie uma Mensagem */}
          <form
            className="message-form"
            action="https://formspree.io/f/xjkrkqyy"
            method="POST"
          >
            <h2 className="section-title">Envie uma Mensagem</h2>

            <div className="form-field">
              <strong className="field-label">Nome</strong>
              <input
                type="text"
                name="name"
                className="field-input"
                placeholder="Seu nome"
                required
              />
            </div>

            <div className="form-field">
              <strong className="field-label">Email</strong>
              <input
                type="email"
                name="email"
                className="field-input"
                placeholder="seu.email@exemplo.com"
                required
              />
            </div>

            <div className="form-field">
              <strong className="field-label">Mensagem</strong>
              <textarea
                name="message"
                className="field-textarea"
                placeholder="Digite sua mensagem aqui..."
                rows="4"
                required
              ></textarea>
            </div>

            <button type="submit" className="submit-button">
              <FaPaperPlane className="button-icon" />
              Enviar Mensagem
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
